import frontendAppAuthnMessages from './messages/@openedx/frontend-app-authn';
import frontendAppInstructorDashboardMessages from './messages/@openedx/frontend-app-instructor-dashboard';
import frontendAppLearnerDashboardMessages from './messages/@openedx/frontend-app-learner-dashboard';
import frontendBaseMessages from './messages/@openedx/frontend-base';
import paragonMessages from './messages/@openedx/paragon';

export default [
  frontendAppAuthnMessages,
  frontendAppInstructorDashboardMessages,
  frontendAppLearnerDashboardMessages,
  frontendBaseMessages,
  paragonMessages,
];
